export class Award {
	constructor(data) {
		this._id = data._id;
		this.description = data.description;
		this.points = data.points;
		this.status = data.status;
		this.picture = data.picture;
	}
}
